import { Button } from '@skyline-platform/alchemy';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { handleEnterKeyDown } from '@components/FormComponents/helpers';

export const ActionsContent = (props) => {
  const {
    title,
    description,
    children,
    confirmBtnLabel = 'Update',
    confirmBtnState = 'default',
    confirmAction,
    confirmBtnTitle,
  } = props;

  const buttonRef = useRef(null);
  const handleCancel = (event) => {
    if (event.key == 'Space' || event.type === 'click') {
      // Simulate key press to close the menu
      const escapeEvent = new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true,
      });
      buttonRef.current.focus();
      buttonRef.current.dispatchEvent(escapeEvent);
    };
  };

  return (
    <>
      <h2>{title}</h2>
      <p>{description}</p>
      {children}
      <div className='button-group'>
        <Button
          ref={buttonRef}
          label='Cancel'
          handleClick={handleCancel}
          onKeyDown={handleCancel}
        />
        <Button
          label={confirmBtnLabel}
          state={confirmBtnState}
          type='filled'
          handleClick={confirmAction}
          onKeyDown={(event) => handleEnterKeyDown(event, confirmAction)}
          title={confirmBtnTitle ?? (confirmBtnState === 'disabled' ? 'No rows selected' : undefined)}
        />
      </div>
    </>
  );
};

ActionsContent.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  confirmBtnLabel: PropTypes.string,
  confirmBtnState: PropTypes.string,
  confirmBtnTitle: PropTypes.string,
  confirmAction: PropTypes.func.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
